<div class="purchase-request-create-dialog">
    <div style="display: flex; justify-content: flex-end; padding-right: 21px; margin-bottom: 10px;"
        *ngIf="mode === 'actions' && staffView && !isReadOnly">
        <ppl-button (click)="onPrint()" label="Print" icon="fa fa-print"
        [customClass]="'primary-button'" [iconPosition]="'right'"></ppl-button>
    </div>
    <div id="print-section">
        <form nz-form nz-row [formGroup]="purchaseRequestForm" class="m-4"
            [ngClass]="{ 'view-mode': mode !== 'add', 'edit-mode': mode === 'add' }">
            <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item nz-padding-left">
                <nz-row>
                    <nz-form-label [nzSm]="8" [nzXs]="24" class="ppl-form-label" nzFor="participantPplId">
                        Participant PPL ID @if(mode === 'add' && staffView){<span class="form-required-field"> *</span>}
                    </nz-form-label>
                    <nz-form-control class="ppl-form-control">
                        @if(mode === 'add' && staffView) {
                        <div class="flex-container">
                            <div class="participant-id-flex-item">
                                <input nz-tooltip nzTooltipTitle="Please enter the Participant PPL ID"
                                    nzTooltipPlacement="topRight" nz-input formControlName="participantPplId"
                                    id="participantPplId" placeholder="Participant PPL ID"
                                    [ngClass]="{'error': validationErrors['participantPplId'] || purchaseRequestForm.get('participantPplId')?.hasError('pattern') }" />
                            </div>
                            @if(staffView){
                            <ppl-button class="get-participant-flex-item" label="Get Participant"
                                (click)="getConsumerDetails()" [customClass]="'primary-button'"
                                [iconPosition]="'left'" [disabled]="!!purchaseRequestForm.get('participantPplId')?.invalid"></ppl-button>
                            }
                        </div>
                        @if (validationErrors['participantPplId']) {
                        <span class="pl-1 error-message">{{validationErrors['participantPplId']}}</span>
                        }
                        @if (purchaseRequestForm.get('participantPplId')?.hasError('pattern') && purchaseRequestForm.get('participantPplId')?.touched) {
                        <span class="pl-1 error-message">Participant PPL ID must start with PRC-CASDP- or PA- and contain only letters, numbers, and -</span>
                        }
                        } @else {
                        <div class="participant-id-flex-item">
                            <span>{{ purchaseRequestData?.participantPplId ?? consumerData?.participantPplId }}</span>
                        </div>
                        }
                    </nz-form-control>
                </nz-row>
            </nz-form-item>
            @if(isParticipantSelected || mode !== 'add') {
            <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item nz-padding-left">
                <nz-row>
                    <nz-form-label [nzSm]="8" [nzXs]="24" class="ppl-form-label" nzFor="participantName">
                        Participant Name
                    </nz-form-label>
                    <nz-form-control class="ppl-form-control">
                        <div class="participant-id-flex-item" [ngClass]="{'error': validationErrors['participantName'] }">
                            <span>{{ mode === 'add' ? purchaseRequestForm.get('participantName')?.value :
                                purchaseRequestData?.consumerName }}</span>
                        </div>
                    </nz-form-control>
                </nz-row>
            </nz-form-item>
            <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item nz-padding-left">
                <nz-row>
                    <nz-form-label [nzSm]="8" [nzXs]="24" class="ppl-form-label" nzFor="participantAddress">
                        Participant Address
                    </nz-form-label>
                    <nz-form-control class="ppl-form-control">
                        <div class="participant-id-flex-item"
                            [ngClass]="{'error': validationErrors['participantAddress'] }">
                            <span>{{ mode === 'add' ? purchaseRequestForm.get('participantAddress')?.value :
                                purchaseRequestData?.participantAddress }}</span>
                        </div>
                    </nz-form-control>
                </nz-row>
            </nz-form-item>
            @if(mode === 'add') {
            <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item nz-padding-left">
                <nz-row>
                    <div class="custom-row">
                        <label nz-checkbox formControlName="isShippingAddressDifferent"
                            (nzCheckedChange)="onCheckUnCheck($event)">
                            Check this box if you need this shipped to a different address
                        </label>
                    </div>
                </nz-row>
            </nz-form-item>
            @if(isShippingAddressChecked) {
            <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item nz-padding-left">
                <nz-row>
                    <nz-form-label [nzSm]="8" [nzXs]="24" class="ppl-form-label" nzFor="participantShippingAddress">
                        Shipping Address <span class="form-required-field"> *</span>
                    </nz-form-label>
                    <nz-form-control class="ppl-form-control">
                        <div class="participant-id-flex-item">
                            <span>{{ selectedShippingAddress }}</span>
                        </div>
                    </nz-form-control>
                </nz-row>
            </nz-form-item>
            <nz-form-item class="ppl-form-item">
                <nz-row>
                    <ppl-address #shippingAddressComponent [addressForm]="getFormGroup('participantShippingAddress')"
                        [isMandatory]="isShippingAddressChecked" [mailingValidationErrors]="mailingValidationErrors"
                        [is_permanent]="false" [showPSD]="false" [showFullAddress]="false"
                        (onAddressSelection)="onShippingAddressSelected($event)">
                    </ppl-address>
                </nz-row>
            </nz-form-item>
            }
            } @else {
            <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item nz-padding-left">
                <nz-row>
                    <nz-form-label [nzSm]="8" [nzXs]="24" class="ppl-form-label" nzFor="participantShippingAddress">
                        Shipping Address
                    </nz-form-label>
                    <nz-form-control class="ppl-form-control">
                        <div class="participant-id-flex-item">
                            <span>{{ purchaseRequestData?.shippingAddress }}</span>
                        </div>
                    </nz-form-control>
                </nz-row>
            </nz-form-item>
            }
            <nz-divider class="divider"></nz-divider>
            <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item nz-padding-left">
                <nz-row>
                    <nz-form-label [nzSm]="8" [nzXs]="24" class="ppl-form-label" nzFor="vendorName">
                        Merchant's Name @if(mode === 'add'){<span class="form-required-field"> *</span>}
                    </nz-form-label>
                    <nz-form-control class="ppl-form-control">
                        @if(mode === 'add') {
                        <div>
                            <input nz-tooltip nzTooltipTitle="Please enter the Merchant's Name"
                                nzTooltipPlacement="topRight" nz-input formControlName="vendorName" id="vendorName"
                                placeholder="Merchant's Name"
                                [ngClass]="{'error': purchaseRequestForm.get('vendorName')?.invalid && purchaseRequestForm.get('vendorName')?.touched }" />
                        </div>
                        @if (purchaseRequestForm.get('vendorName')?.invalid &&
                        purchaseRequestForm.get('vendorName')?.touched) {
                        <span class="pl-1 error-message">Please enter the Merchant's Name</span>
                        }
                        } @else {
                        <div class="participant-id-flex-item">
                            <span>{{ purchaseRequestData?.vendorName }}</span>
                        </div>
                        }
                    </nz-form-control>
                </nz-row>
            </nz-form-item>
            <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item nz-padding-left">
                <nz-row>
                    <nz-form-label [nzSm]="8" [nzXs]="24" class="ppl-form-label" nzFor="vendorPhoneNumber">
                        Merchant's Phone Number @if(mode === 'add'){<span class="form-required-field"> *</span>}
                    </nz-form-label>
                    <nz-form-control class="ppl-form-control">
                        @if(mode === 'add') {
                        <div [ngClass]="{'error': validationErrors['vendorPhoneNumber'] }">
                            <input nz-tooltip nzTooltipTitle="Please enter the Merchant's Phone Number" maxlength="10"
                                nzTooltipPlacement="topRight" nz-input formControlName="vendorPhoneNumber"
                                id="vendorPhoneNumber" placeholder="Merchant's Phone Number"
                                [ngClass]="{'error': purchaseRequestForm.get('vendorPhoneNumber')?.invalid && purchaseRequestForm.get('vendorPhoneNumber')?.touched }" />
                        </div>
                        @if (purchaseRequestForm.get('vendorPhoneNumber')?.invalid &&
                        purchaseRequestForm.get('vendorPhoneNumber')?.touched) {
                        <span class="pl-1 error-message">Please enter the Merchant's Phone Number</span>
                        }
                        } @else {
                        <div class="participant-id-flex-item">
                            <span>{{ purchaseRequestData?.vendorPhoneNumber }}</span>
                        </div>
                        }
                    </nz-form-control>
                </nz-row>
            </nz-form-item>
            <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item nz-padding-left">
                <nz-row>
                    <nz-form-label [nzSm]="8" [nzXs]="24" class="ppl-form-label" nzFor="vendorContactName">
                        Contact Name
                    </nz-form-label>
                    <nz-form-control class="ppl-form-control">
                        @if(mode === 'add') {
                        <div [ngClass]="{'error': validationErrors['vendorContactName'] }">
                            <input nz-tooltip nzTooltipTitle="Please enter the Contact Name"
                                nzTooltipPlacement="topRight" nz-input formControlName="vendorContactName" id="vendorContactName"
                                placeholder="Contact Name" [ngClass]="{'error': validationErrors['vendorContactName'] }" />
                        </div>
                        } @else {
                        <div class="participant-id-flex-item">
                            <span>{{ purchaseRequestData?.vendorContactName }}</span>
                        </div>
                        }
                    </nz-form-control>
                </nz-row>
            </nz-form-item>
            <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item nz-padding-left">
                <nz-row>
                    <nz-form-label [nzSm]="8" [nzXs]="24" class="ppl-form-label" nzFor="vendorUrl">
                        Merchant's Website Address
                    </nz-form-label>
                    <nz-form-control class="ppl-form-control">
                        @if(mode === 'add') {
                        <div [ngClass]="{'error': validationErrors['vendorUrl'] }">
                            <input maxlength="150" nz-tooltip nzTooltipTitle="Please enter the Merchant's Website Address"
                                nzTooltipPlacement="topRight" nz-input formControlName="vendorUrl" id="vendorUrl"
                                placeholder="Merchant's Website Address"
                                [ngClass]="{'error': validationErrors['vendorUrl'] }" />
                        </div>
                        } @else {
                        <div class="participant-id-flex-item">
                            <span>{{ purchaseRequestData?.vendorUrl }}</span>
                        </div>
                        }
                    </nz-form-control>
                </nz-row>
            </nz-form-item>
            <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item nz-padding-left special-instruction-form-item">
                <nz-row>
                    <nz-form-label [nzSm]="8" [nzXs]="24" class="ppl-form-label" nzFor="vendorSpecialInstruction">
                        Special Instructions
                    </nz-form-label>
                    <nz-form-control class="ppl-form-control">
                        @if(mode === 'add') {
                        <div>
                            <textarea rows="4" nz-tooltip nzTooltipTitle="Please enter the Special Instructions"
                                nzTooltipPlacement="topRight" nz-input formControlName="vendorSpecialInstruction"
                                id="vendorSpecialInstruction" placeholder="Special Instructions"></textarea>
                        </div>
                        } @else {
                        <div class="participant-id-flex-item">
                            <span>{{ purchaseRequestData?.specialInstruction }}</span>
                        </div>
                        }
                    </nz-form-control>
                </nz-row>
            </nz-form-item>
            <nz-divider class="divider"></nz-divider>
            @if(noServiceCodeAvailableMessage) {
                <div class="w-100 alert alert-warning d-flex justify-content-between align-items-center">
                    <span>{{noServiceCodeAvailableMessage}}</span>
                </div>
            }
            <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item nz-padding-left">
                <nz-row>
                    <nz-form-label [nzSm]="8" [nzXs]="24" class="ppl-form-label" nzFor="serviceCode">
                        Service Code @if(mode === 'add'){<span class="form-required-field"> *</span>}
                    </nz-form-label>
                    <nz-form-control class="ppl-form-control">
                        @if(mode === 'add') {
                        <div>
                            <nz-select class="ppl-select" id="serviceCode" formControlName="serviceCode"
                                nzPlaceHolder="Select Service Code" nzShowSearch nzAllowClear
                                [ngClass]="{'error': purchaseRequestForm.get('serviceCode')?.invalid && purchaseRequestForm.get('serviceCode')?.touched }"
                                (ngModelChange)="onServiceCodeSelection($event)">
                                @for(opt of serviceCodeList; track $index){
                                <nz-option [nzLabel]="opt.serviceCodeDetail"
                                    [nzValue]="opt.serviceCodeDetailId"></nz-option>
                                }
                            </nz-select>
                        </div>
                        @if (purchaseRequestForm.get('serviceCode')?.invalid &&
                        purchaseRequestForm.get('serviceCode')?.touched) {
                        <span class="pl-1 error-message">Please select the Service Code</span>
                        }
                        } @else {
                        <div class="participant-id-flex-item">
                            <span>{{ purchaseRequestData?.service }}</span>
                        </div>
                        }
                    </nz-form-control>
                </nz-row>
            </nz-form-item>
            <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item nz-padding-left">
                <nz-row>
                    <nz-form-label [nzSm]="8" [nzXs]="24" class="ppl-form-label" nzFor="serviceDescription">
                        Service Description @if(mode === 'add'){<span class="form-required-field"> *</span>}
                    </nz-form-label>
                    <nz-form-control class="ppl-form-control">
                        @if(mode === 'add') {
                        <div>
                            <nz-select class="ppl-select" id="serviceDescription" formControlName="serviceDescription"
                                nzPlaceHolder="Select Service Description" nzShowSearch nzAllowClear
                                [ngClass]="{'error': purchaseRequestForm.get('serviceDescription')?.invalid && purchaseRequestForm.get('serviceDescription')?.touched }">
                                @for(opt of serviceDescriptionList; track $index){
                                <nz-option [nzLabel]="opt.desc" [nzValue]="opt.ids"></nz-option>
                                }
                            </nz-select>
                        </div>
                        @if (purchaseRequestForm.get('serviceDescription')?.invalid &&
                        purchaseRequestForm.get('serviceDescription')?.touched) {
                        <span class="pl-1 error-message">Please select the Service Description</span>
                        }
                        } @else {
                        <div class="participant-id-flex-item">
                            <span>{{ purchaseRequestData?.serviceDescription }}</span>
                        </div>
                        }
                    </nz-form-control>
                </nz-row>
            </nz-form-item>

            @if(mode === 'add') {
            <div class="consumer-view-button-row">
                <ppl-button label=" Add new entry" icon="fa fa-plus" [customClass]="'primary-button'"
                    (handleClick)="addNewEntry()" [iconPosition]="'left'"></ppl-button>
            </div>
            }

            <table class="table mt-4">
                <thead>
                    <tr>
                        <th style="background-color: #a8e4e14d;" [ngStyle]="{ 'width': mode === 'add' ? '25%' : '20%' }">
                            Item Description
                            @if(mode === 'add') {
                                <span class="form-required-field"> *</span>
                            }
                        </th>
                        <th style="background-color: #a8e4e14d;" [ngStyle]="{ 'width': mode === 'add' ? '25%' : '20%' }">
                            URL
                            @if(mode === 'add') {
                                <span class="form-required-field"> *</span>
                            }
                        </th>
                        <th style="background-color: #a8e4e14d;" [ngStyle]="{ 'width': mode === 'add' ? '10%' : '8%' }">
                            Quantity
                            @if(mode === 'add'){
                                <span class="form-required-field">*</span>
                            }
                        </th>
                        <th style="background-color: #a8e4e14d;" [ngStyle]="{ 'width': mode === 'add' ? '15%' : '12%' }">
                            Price per item
                            @if(mode === 'add'){
                                <span class="form-required-field"> *</span>
                            }
                        </th>
                        @if (mode !== 'add') {
                            <th style="background-color: #a8e4e14d; width: 15%;">
                                Business Status
                            </th>
                            <th style="background-color: #a8e4e14d; width: 15%;">
                                Processing Status
                            </th>
                        }
                        <th style="background-color: #a8e4e14d;" [ngStyle]="{ 'width': mode === 'add' ? '15%' : '10%' }">
                            Total Price
                        </th>
                        @if(mode === 'add' || staffView) {
                            <th style="background-color: #a8e4e14d; width: 10%;">
                                Actions
                            </th>
                        }
                    </tr>
                </thead>
                <tbody formArrayName="purchaseRequestEntries" class="purchase-request-entries">
                    <tr *ngFor="let entry of purchaseRequestEntries.controls; let i = index" [formGroupName]="i">
                        <td>
                            @if(mode === 'add') {
                                <input nz-input formControlName="itemDescription" id="itemDescription{{i}}"
                                    [ngClass]="{ 'error-border': isFormSubmitRequested && isFieldEmpty('itemDescription', i) }" />
                                @if(isFormSubmitRequested && isFieldEmpty('itemDescription', i)) {
                                <span class="pl-1 error-message">Item description is required</span>
                                }
                            } @else {
                                <label for="itemDescription">{{ entry.get('itemDescription')?.value }}</label>
                            }
                        </td>
                        <td>
                            @if(mode === 'add') {
                                <input nz-input formControlName="serviceUrl" id="serviceUrl{{i}}"
                                    [ngClass]="{ 'error-border': isFormSubmitRequested && isFieldEmpty('serviceUrl', i) }" />
                                @if(isFormSubmitRequested && isFieldEmpty('serviceUrl', i)) {
                                <span class="pl-1 error-message">URL is required</span>
                                }
                            } @else {
                                <label for="serviceUrl">{{ entry.get('serviceUrl')?.value }}</label>
                            }
                        </td>
                        <td>
                            @if(mode === 'add' || (!entriesProcessingStatusError && this.purchaseRequestData.statusLkp.trim().toLowerCase() === 'submitted')) {
                                <input nz-input formControlName="serviceUnits" id="serviceUnits{{i}}" numberOnly
                                    [ngClass]="{ 'error-border': isFormSubmitRequested && isFieldEmpty('serviceUnits', i) }" />
                                @if(isFormSubmitRequested && isFieldEmpty('serviceUnits', i)) {
                                <span class="pl-1 error-message">Quantity is required</span>
                                }
                            } @else {
                                <label for="serviceUnits">{{ entry.get('serviceUnits')?.value }}</label>
                            }
                        </td>
                        <td>
                            @if(mode === 'add' || (!entriesProcessingStatusError && this.purchaseRequestData.statusLkp.trim().toLowerCase() === 'submitted')) {
                                <nz-input-group nzAddOnBefore="$">
                                    <input nz-input formControlName="rate" id="rate{{i}}"
                                        [ngClass]="{ 'error-border': isFormSubmitRequested && isFieldEmpty('rate', i) }" />
                                </nz-input-group>
                                @if(isFormSubmitRequested && isFieldEmpty('rate', i)) {
                                <span class="pl-1 error-message">Price per item is required</span>
                                }
                            } @else {
                                <label for="rate">{{ entry.get('rate')?.value | currency:'USD':'symbol':'1.2-2' }}</label>
                            }
                        </td>
                        @if(mode !== 'add') {
                            <td>
                                <label for="businessStatus">{{ entry.get('businessStatus')?.value }}</label>
                            </td>
                            <td>
                            @if (entry.get('prcocessingStatus')?.value === 'Pended' || entry.get('prcocessingStatus')?.value == 'Denied'){
                                <label for="prcocessingStatus" class="success-status hyperlink" 
                                    (click)="viewPurchaseRequestPendDetails(entry.get('prcocessingStatus')?.value, entry.get('id')?.value)">
                                    {{ entry.get('prcocessingStatus')?.value }}
                                </label>
                            } @else {
                                <label for="prcocessingStatus">{{ entry.get('prcocessingStatus')?.value }}</label>
                            }
                            </td>
                        }
                        <td>
                            <strong>{{ purchaseRequestEntries.get([i, 'totalCost'])?.value |
                                currency:'USD':'symbol':'1.2-2'
                                }}</strong>
                        </td>
                        <td>
                            <div class="button-container mr-2">
                                @if(mode === 'add') {
                                <ppl-button size="small" ariaLabel="Delete" label="Delete" icon="pi pi-trash"
                                    [customClass]="'ghost-button'" [iconPosition]="'left'" [hideLabel]="true"
                                    (click)="deleteRow(i)"></ppl-button>
                                }
                                @if(mode != 'add' && staffView) {
                                <ppl-button size="small" ariaLabel="Edit History" label="Edit History" icon="fa fa-history"
                                    [customClass]="'ghost-button'" [iconPosition]="'left'" [hideLabel]="true"
                                    (click)="openEditHistoryDialog(i)"></ppl-button>

                                <ppl-button size="small" ariaLabel="Audit History" label="Audit History" icon="fa fa-file-alt"
                                    [customClass]="'ghost-button'" [iconPosition]="'left'" [hideLabel]="true"
                                    (click)="openAuditHistoryDialog(i)"></ppl-button>
                                }
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="grand-total">
                <nz-row class="ppl-mt10 ppl-mb10 mt-4" style="text-align: right;">
                    <nz-col [nzSpan]="24" class="text-right">
                        <b>Item Total Amount: {{ getTotalPurchaseRequestAmount() | currency:'USD':'symbol':'1.2-2'
                            }}</b>
                    </nz-col>
                </nz-row>
            </div>
            <nz-divider class="divider"></nz-divider>
            @if (mode === 'add' || filesListLoaded) {
            <nz-form-item class="ppl-form-item attachment-form-item">
                <nz-row>
                    <nz-form-label [nzSpan]="24" class="ppl-form-label">
                        Attachments
                    </nz-form-label>
                    <nz-form-control [nzSpan]="24" class="ppl-form-control">
                        <ppl-upload [showFileList]="true" [disableFileTypeSelection]="true"
                            [fileType]="'Purchase Request Receipt'" [disableUploadButton]="mode !== 'add'"
                            [showFileList]="true" [fileList]="uploadedFiles" [consumerId]="selectedParticipantId"
                            [source]="'purchaserequest'" [showDownloadButton]="showDownloadButton"
                            [showDeleteButton]="showDeleteButton" (fileSelected)="onFileSelected($event)"
                            (fileRemoved)="onFileRemoved($event)"
                            (downloadRequested)="onDownloadRequested($event)"></ppl-upload>
                    </nz-form-control>
                </nz-row>
            </nz-form-item>
            }
            @if(mode === 'actions' && staffView && canApproveReject && purchaseRequestData?.statusLkp === 'SUBMITTED') {
                @if(entriesProcessingStatusError) {
                    <div class="w-100 alert alert-warning d-flex justify-content-between align-items-center">
                        <span>{{entriesProcessingStatusErrorMessage}}</span>
                    </div>
                }
                <div class="staff-view-button-row">
                    @if (!entriesProcessingStatusError) {
                        <ppl-button label="Approve" icon="fa fa-check-circle" [customClass]="'primary-button'"
                            (handleClick)="purchaseRequestApprove()" [iconPosition]="'left'"></ppl-button>
                    }
                    <ppl-button label="Reject" icon="fa fa-" [customClass]="'ghost-button'"
                        (handleClick)="purchaseRequestReject()" [iconPosition]="'left'"></ppl-button>
                </div>
            }
            @if(mode !== 'add' && purchaseRequestData?.statusLkp !== 'SUBMITTED') {
            <nz-divider class="divider"></nz-divider>
            @if(purchaseRequestData?.statusLkp === 'COMPLETED') {
            <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item nz-padding-left"
                *ngFor="let field of orderCompletedFields">
                <nz-row>
                    <nz-form-label [nzSm]="8" [nzXs]="24" class="ppl-form-label" [nzFor]="field.key">
                        {{ field.label }}
                    </nz-form-label>
                    <nz-form-control class="ppl-form-control">
                        <div class="participant-id-flex-item">
                            <span>
                                @if(field.key === 'shippingAmount' || field.key === 'taxAmount' || field.key ===
                                'totalAmount')
                                { $ }
                                {{ purchaseRequestData?.[field.key] }}
                            </span>
                        </div>
                    </nz-form-control>
                </nz-row>
            </nz-form-item>
            } @else if (purchaseRequestData?.statusLkp === 'REJECTED') {
            <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item nz-padding-left"
                *ngFor="let field of orderRejectedFields">
                <nz-row>
                    <nz-form-label [nzSm]="8" [nzXs]="24" class="ppl-form-label" [nzFor]="field.key">
                        {{ field.label }}
                    </nz-form-label>
                    <nz-form-control class="ppl-form-control">
                        <div class="participant-id-flex-item">
                            <span>{{ purchaseRequestData?.[field.key] }}</span>
                        </div>
                    </nz-form-control>
                </nz-row>
            </nz-form-item>
            }
            }
            @if(mode === 'add') {
            @if(showInsufficientAuthMessage) {
                <div class="w-100 alert alert-warning d-flex justify-content-between align-items-center">
                        <span>{{insufficientAuthMessage}}</span>
                        <span class="close-icon" (click)="closeErrorMessage(insufficientAuthMessage)">×</span>
                </div>
            }
            <div class="custom-row" style="width: 100%;">
                <div class="mr-2">
                    <ppl-button (click)="onSave()" [styleString]="'margin-right: 8px; font-size: 1rem'" label="Save"
                        icon="fa fa-check-circle" [customClass]="'primary-button'" [iconPosition]="'left'"></ppl-button>
                </div>
                <div class="mr-2">
                    <ppl-button label="Close" [customClass]="'ghost-button justify-center'" icon="fa fa-times-circle-o"
                        [iconPosition]="'left'" (click)="onCancel()"
                        [styleString]="'white-space: nowrap; font-size: 1rem'"></ppl-button>
                </div>
            </div>
            }
            }
        </form>
    </div>
</div>

<div class="filter-panel">
    <ng-template #approvePurchaseRequestDialog let-cancel="cancel">
        <form nz-form nz-row [formGroup]="approvePurchaseRequestForm" class="m-4">
            <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item nz-padding-left">
                <nz-row>
                    <nz-form-label [nzSm]="8" [nzXs]="24" class="ppl-form-label" nzFor="orderNumber">
                        Order Number
                    </nz-form-label>
                    <nz-form-control class="ppl-form-control">
                        <div>
                            <input nz-tooltip nzTooltipTitle="Please enter the Order Number"
                                nzTooltipPlacement="topRight" nz-input formControlName="orderNumber" id="orderNumber"
                                placeholder="Order Number"
                                [ngClass]="{'error': approvePurchaseRequestForm.get('orderNumber')?.invalid && approvePurchaseRequestForm.get('orderNumber')?.touched }" />
                        </div>
                        @if (approvePurchaseRequestForm.get('orderNumber')?.invalid &&
                        approvePurchaseRequestForm.get('orderNumber')?.touched) {
                        <span class="pl-1 error-message">Please enter the Order Number</span>
                        }
                    </nz-form-control>
                </nz-row>
            </nz-form-item>
            <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item nz-padding-left">
                <nz-row>
                    <nz-form-label [nzSm]="8" [nzXs]="24" class="ppl-form-label" nzFor="pplPurchaseId">
                        PPL Purchase ID @if(mode === 'actions'){<span class="form-required-field"> *</span>}
                    </nz-form-label>
                    <nz-form-control class="ppl-form-control">
                        <div>
                            <input maxlength="16" inputmode="numeric" pattern="[0-9]*" oninput="this.value = this.value.replace(/\D/g, '')"
                                nz-tooltip nzTooltipTitle="Please enter the PPL Purchase ID"
                                nzTooltipPlacement="topRight" nz-input formControlName="pplPurchaseId"
                                id="pplPurchaseId" placeholder="PPL Purchase ID"
                                [ngClass]="{'error': approvePurchaseRequestForm.get('pplPurchaseId')?.invalid && approvePurchaseRequestForm.get('pplPurchaseId')?.touched }" />
                        </div>
                        @if (approvePurchaseRequestForm.get('pplPurchaseId')?.invalid &&
                        approvePurchaseRequestForm.get('pplPurchaseId')?.touched) {
                            <span *ngIf="approvePurchaseRequestForm.get('pplPurchaseId')?.errors?.['required']" class="pl-1 error-message">Please enter the PPL Purchase ID</span>
                            <span *ngIf="approvePurchaseRequestForm.get('pplPurchaseId')?.errors?.['duplicate']" class="pl-1 error-message">Duplicate PPL Purchase ID. Please enter a unique one.</span>
                        }
                    </nz-form-control>
                </nz-row>
            </nz-form-item>
            <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item nz-padding-left">
                <nz-row>
                    <nz-form-label [nzSm]="8" [nzXs]="24" class="ppl-form-label" nzFor="trackingNumber">
                        Tracking Number
                    </nz-form-label>
                    <nz-form-control class="ppl-form-control">
                        <div>
                            <input nz-tooltip nzTooltipTitle="Please enter the Tracking Number"
                                nzTooltipPlacement="topRight" nz-input formControlName="trackingNumber"
                                id="trackingNumber" placeholder="Tracking Number"
                                [ngClass]="{'error': approvePurchaseRequestForm.get('trackingNumber')?.invalid && approvePurchaseRequestForm.get('trackingNumber')?.touched }" />
                        </div>
                        @if (approvePurchaseRequestForm.get('trackingNumber')?.invalid &&
                        approvePurchaseRequestForm.get('trackingNumber')?.touched) {
                        <span class="pl-1 error-message">Please enter the Tracking Number</span>
                        }
                    </nz-form-control>
                </nz-row>
            </nz-form-item>
            <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item nz-padding-left">
                <nz-row>
                    <nz-form-label [nzSm]="8" [nzXs]="24" class="ppl-form-label" nzFor="itemsAmount">
                        Items Amount
                    </nz-form-label>
                    <nz-form-control class="ppl-form-control">
                        <div>
                            <label for="itemsAmount">{{ approvePurchaseRequestForm.get('itemsAmount')?.value | currency:'USD':'symbol':'1.2-2' }}</label>
                        </div>
                    </nz-form-control>
                </nz-row>
            </nz-form-item>
            <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item nz-padding-left">
                <nz-row>
                    <nz-form-label [nzSm]="8" [nzXs]="24" class="ppl-form-label" nzFor="shippingAmount">
                        Shipping & Handling Amount
                    </nz-form-label>
                    <nz-form-control class="ppl-form-control">
                        <div>
                            <nz-input-group nzAddOnBefore="$">
                                <input nz-tooltip nzTooltipTitle="Please enter the Shipping & Handling Amount"
                                    nzTooltipPlacement="topRight" nz-input formControlName="shippingAmount"
                                    id="shippingAmount" placeholder="Shipping & Handling Amount"
                                    [ngClass]="{'error': approvePurchaseRequestForm.get('shippingAmount')?.invalid && approvePurchaseRequestForm.get('shippingAmount')?.touched }" />
                            </nz-input-group>
                        </div>
                        @if(approvePurchaseRequestForm.get('shippingAmount')?.hasError('invalidAmount')) {
                        <span class="pl-1 error-message">Please enter a valid amount (numbers only, up to 2
                            decimals)</span>
                        } @else if (approvePurchaseRequestForm.get('shippingAmount')?.invalid &&
                        approvePurchaseRequestForm.get('shippingAmount')?.touched) {
                        <span class="pl-1 error-message">Please enter the Shipping & Handling Amount</span>
                        }
                    </nz-form-control>
                </nz-row>
            </nz-form-item>
            <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item nz-padding-left">
                <nz-row>
                    <nz-form-label [nzSm]="8" [nzXs]="24" class="ppl-form-label" nzFor="taxAmount">
                        Tax Amount
                    </nz-form-label>
                    <nz-form-control class="ppl-form-control">
                        <div>
                            <nz-input-group nzAddOnBefore="$">
                                <input nz-input nz-tooltip nzTooltipTitle="Please enter the Tax Amount"
                                    placeholder="Tax Amount" nzTooltipPlacement="topRight" formControlName="taxAmount"
                                    id="taxAmount"
                                    [ngClass]="{'error': approvePurchaseRequestForm.get('taxAmount')?.invalid && approvePurchaseRequestForm.get('taxAmount')?.touched }" />
                            </nz-input-group>
                        </div>
                        @if(approvePurchaseRequestForm.get('taxAmount')?.hasError('invalidAmount')) {
                        <span class="pl-1 error-message">Please enter a valid amount (numbers only, up to 2
                            decimals)</span>
                        }
                    </nz-form-control>
                </nz-row>
            </nz-form-item>
            <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item nz-padding-left">
                <nz-row>
                    <nz-form-label [nzSm]="8" [nzXs]="24" class="ppl-form-label" nzFor="totalAmount">
                        Total Amount
                    </nz-form-label>
                    <nz-form-control class="ppl-form-control">
                        <div>
                            <label for="totalAmount">{{ approvePurchaseRequestForm.get('totalAmount')?.value | currency:'USD':'symbol':'1.2-2' }}</label>
                        </div>
                        @if(approvePurchaseRequestForm.get('totalAmount')?.hasError('invalidAmount')) {
                        <span class="pl-1 error-message">Please enter a valid amount (numbers only, up to 2
                            decimals)</span>
                        } @else if (approvePurchaseRequestForm.get('totalAmount')?.invalid &&
                        approvePurchaseRequestForm.get('totalAmount')?.touched) {
                        <span class="pl-1 error-message">Please enter the Total Amount</span>
                        }
                    </nz-form-control>
                </nz-row>
            </nz-form-item>
            <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item nz-padding-left">
                <nz-row>
                    <nz-form-label [nzSm]="8" [nzXs]="24" class="ppl-form-label" nzFor="remarks">
                        Approval Remarks @if(mode === 'actions'){<span class="form-required-field"> *</span>}
                    </nz-form-label>
                    <nz-form-control class="ppl-form-control">
                        <div>
                            <input nz-tooltip nzTooltipTitle="Please enter the Approval Remarks"
                                nzTooltipPlacement="topRight" nz-input formControlName="remarks" id="remarks"
                                placeholder="Approval Remarks"
                                [ngClass]="{'error': approvePurchaseRequestForm.get('remarks')?.invalid && approvePurchaseRequestForm.get('remarks')?.touched }" />
                        </div>
                        @if (approvePurchaseRequestForm.get('remarks')?.invalid &&
                        approvePurchaseRequestForm.get('remarks')?.touched) {
                        <span class="pl-1 error-message">Please enter the Approval Remarks</span>
                        }
                    </nz-form-control>
                </nz-row>
            </nz-form-item>
            @if(approvePurchaseRequestError) {
                <div class="w-100 alert alert-danger d-flex justify-content-between align-items-center">
                    <span>{{approvePurchaseRequestError}}</span>
                </div>
            }
            <div style="display: flex; justify-content: flex-end; margin-top: 16px; width: 100%;">
                <ppl-button (click)="handleApprovePurchaseRequestSubmit()" label="Approve"
                    icon="fa fa-check-circle" [customClass]="'primary-button'" [iconPosition]="'left'"></ppl-button>
            </div>
        </form>
    </ng-template>
</div>

<div class="filter-panel">
    <ng-template #rejectPurchaseRequestDialog let-cancel="cancel">
        <form nz-form nz-row [formGroup]="rejectPurchaseRequestForm" class="m-4">
            <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item nz-padding-left">
                <nz-row>
                    <nz-form-label [nzSm]="8" [nzXs]="24" class="ppl-form-label" nzFor="rejectionReasonLkp">
                        Reject Reason @if(mode === 'actions'){<span class="form-required-field"> *</span>}
                    </nz-form-label>
                    <nz-form-control class="ppl-form-control">
                        <div>
                            <nz-select class="ppl-select" id="rejectionReasonLkp" formControlName="rejectionReasonLkp"
                                nzPlaceHolder="Select Rejection Reason" nzShowSearch nzAllowClear
                                [ngClass]="{'error': rejectPurchaseRequestForm.get('rejectionReasonLkp')?.invalid && rejectPurchaseRequestForm.get('rejectionReasonLkp')?.touched }">
                                @for(opt of rejectPurchaseRequestReasonList; track $index){
                                <nz-option [nzLabel]="opt.lkpValueName" [nzValue]="opt.lkpValueName"></nz-option>
                                }
                            </nz-select>
                        </div>
                        @if (rejectPurchaseRequestForm.get('rejectionReasonLkp')?.invalid &&
                        rejectPurchaseRequestForm.get('rejectionReasonLkp')?.touched) {
                        <span class="pl-1 error-message">Please select the Rejection Reason</span>
                        }
                    </nz-form-control>
                </nz-row>
            </nz-form-item>
            <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item nz-padding-left">
                <nz-row>
                    <nz-form-label [nzSm]="8" [nzXs]="24" class="ppl-form-label" nzFor="remarks">
                        Reject Remarks
                    </nz-form-label>
                    <nz-form-control class="ppl-form-control">
                        <div>
                            <input nz-tooltip nzTooltipTitle="Please enter the Rejection Remarks"
                                nzTooltipPlacement="topRight" nz-input formControlName="remarks" id="remarks"
                                placeholder="Rejection Remarks" />
                        </div>
                    </nz-form-control>
                </nz-row>
            </nz-form-item>
            <div style="display: flex; justify-content: flex-end; width: 100%;">
                <ppl-button (click)="handleRejectPurchaseRequestSubmit()" label="Reject"
                    icon="fa fa-check-circle" [customClass]="'primary-button'" [iconPosition]="'left'"></ppl-button>
            </div>
        </form>
    </ng-template>
</div>

<div class="filter-panel">
    <ng-template #pendedDialog let-cancel="cancel">
        <ppl-timesheet-staff-errorcode [errorcodeData]="errorcodeData"
            [disabled]="true"></ppl-timesheet-staff-errorcode>
    </ng-template>
</div>

<div class="filter-panel">
    <ng-template #purchaseRequestEditHistoryDialog let-cancel="cancel">
        <ppl-purchase-request-edit-history [purchaseRequestLineId]="selectedPurchaseRequestLineId"></ppl-purchase-request-edit-history>
    </ng-template>
</div>

<div class="filter-panel">
    <ng-template #purchaseRequestAuditHistoryDialog let-cancel="cancel">
        <ppl-audit-history [auditEntryId]="selectedPurchaseRequestLineId" [flow]="'purchaserequest'"
            [programCode]="programName"
            [lineDetailId]="selectedLineDetailId"></ppl-audit-history>
    </ng-template>
</div>
